import { trigger, transition, style, animate } from '@angular/animations';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboardtile',
  templateUrl: './dashboardtile.component.html',
  styleUrls: ['./dashboardtile.component.scss'],
  animations: [
    trigger(
      'inOutAnimation', 
      [
        transition(
          ':enter', 
          [
            style({ 'max-height': 0 }),
            animate('0.5s ease-out', 
                    style({ 'max-height': 90}))
          ]
        ),
        transition(
          ':leave', 
          [
            style({ 'max-height': 90}),
            animate('0.5s ease-in', 
                    style({ 'max-height': 0}))
          ]
        )
      ]
    ),
    trigger(
      'inOutAnimationContent', 
      [
        transition(
          ':enter', 
          [
            style({ 'max-height': 0 }),
            animate('0.3s ease-out', 
                    style({ 'max-height': 60}))
          ]
        ),
        transition(
          ':leave', 
          [
            style({ 'max-height': 60}),
            animate('0.3s ease-in', 
                    style({ 'max-height': 0}))
          ]
        )
      ]
    )
  ]
})
export class DashboardtileComponent implements OnInit {

  @Input() dashBoardDetails: any = {};
  
  isShowHidedContent: boolean = false;
  isShowHidedContentTile: boolean = false;
  
  constructor() { }

  public changeHidedContentStatus(){
    

    if (!this.isShowHidedContentTile) {
      this.isShowHidedContent = !this.isShowHidedContent;
      setTimeout(() => {
        this.isShowHidedContentTile = !this.isShowHidedContentTile;
      }, 1)
    }else{
      this.isShowHidedContentTile = !this.isShowHidedContentTile;
      setTimeout(() => {
        this.isShowHidedContent = !this.isShowHidedContent;
      }, 1)
    }
    
    console.log('------------',this.isShowHidedContent)
  }
  ngOnInit(): void {

  }

}
